/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Modal, Button } from 'react-bootstrap'
import { postRequestOptions, getRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Spinner from 'react-bootstrap/Spinner'

interface ItemCategoryCreateProps {
	show: boolean;
	handleClose: any;
	id: number;
}

interface InitialState {
	idItemCategories: number | null;
	parentId: number | null;
	categoryName: string;
	categoryPrefix: string;
}


const ItemCategoryCreate: React.FC<ItemCategoryCreateProps> = ({ show, handleClose, id }) => {


	const initialState: InitialState = {
		idItemCategories: null,
		parentId: null,
		categoryName: '',
		categoryPrefix: '',
	};

	const [itemCategory, setItemCategory] = useState(initialState);
	const [parentCategories, setParentCategories] = useState<any[]>([]);


	useEffect(() => {
		// Fetch parent categories when modal opens
		if (show) {
			fetch(
				process.env.REACT_APP_API_URL + 'itemCategories/parent',
				getRequestOptions()
			)
				.then((resp) => {
					return resp.json()
				})
				.then((resp) => {
					if (resp.success) {
						setParentCategories(resp.data);
					}
				})
				.catch((error) => {
					console.log(error, 'catch the hoop')
				})
		}
	}, [show])

	useEffect(() => {
		if (id === 0) {
			setItemCategory({ idItemCategories: null, parentId: null, categoryName: '', categoryPrefix: '' });

		} else {
			fetch(
				process.env.REACT_APP_API_URL + 'itemCategories/edit/' + id,
				getRequestOptions()
			)
				.then((resp) => {
					return resp.json()
				})
				.then((resp) => {
					setItemCategory({ 
						idItemCategories: resp.data.id_item_categories, 
						parentId: resp.data.parent_id || null,
						categoryName: resp.data.category_name, 
						categoryPrefix: resp.data.category_prefix 
					});
				})
				.catch((error) => {
					console.log(error, 'catch the hoop')
				})
		}
	}, [id]);


	const [isSubmitDisable, setSubmitDisable] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleChange = (e: any) => {
		setItemCategory({ ...itemCategory, [e.target.name]: e.target.value });
	};

	const itemCategorySave = async (event: any) => {
		event.preventDefault()
		setSubmitDisable(true);
		setLoading(true);
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You want to " + (id === 0 ? "create" : "update") + " this Item Category?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Submit it!',
		})
		if (confirm.value) {
			const requestOptions = postRequestOptions(itemCategory)
			try {

				let url = (id === 0) ? `${process.env.REACT_APP_API_URL}itemCategories/store` : `${process.env.REACT_APP_API_URL}itemCategories/update`

				let response = await fetch(
					url,
					requestOptions
				)
				let respData = await response.json()
				if (respData.success === true) {
					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})
					handleClose(respData.success)
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
				setSubmitDisable(false);
				setLoading(false);
			} catch (error) {
				console.log(error, 'catch the hoop')
				setSubmitDisable(false);
				setLoading(false);
			}
		}
	}


	return (
		<Modal show={show} onHide={() => handleClose(false)} size="lg">
			{/* <pre>{JSON.stringify(itemCategory, null, 2)}</pre> */}
			<form onSubmit={itemCategorySave}>
				<Modal.Header closeButton>
					<Modal.Title>{id === 0 ? 'Create' : 'Edit'} Item Category</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<label htmlFor="parentId" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Parent Category</label>
						<div className="col-lg-5">
							<select 
								name="parentId" 
								id="parentId" 
								value={itemCategory.parentId || ''} 
								onChange={(e) => setItemCategory({ ...itemCategory, parentId: e.target.value ? parseInt(e.target.value) : null })} 
								className="form-control form-control-sm"
							>
								<option value="">Select Parent Category</option>
								{parentCategories.map((category) => (
									<option key={category.id_item_categories} value={category.id_item_categories}>
										{category.category_name}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="categoryName" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Name <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<input type="text" name="categoryName" id="categoryName" value={itemCategory.categoryName} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					<div className="form-group row">
						<label htmlFor="categoryPrefix" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Prefix <span className="required text-danger"></span></label>
						<div className="col-lg-5">
							<input type="text" name="categoryPrefix" id="categoryPrefix" value={itemCategory.categoryPrefix} onChange={handleChange} className="form-control form-control-sm" />
						</div>
					</div>
					{/* <pre>{JSON.stringify(company, null, 2)}</pre> */}
				</Modal.Body>
				<Modal.Footer>

					<button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
						{loading &&
							<Spinner
								as="span"
								animation="grow"
								size="sm"
								role="status"
								aria-hidden="true"
							/>
						}
						<span>  Submit</span>
					</button>
					<Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
						Close
					</Button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default ItemCategoryCreate
